import { useI18n } from '@/i18n'
const HACKER_CITY_URL = 'https://hackercity.kajo.tech/'
const BANNER_SRC = '/promo/hacker-city-banner.jpg'

export function SidebarPromo() {
  const { t } = useI18n()
  return (
    <div className="sidebar-promo">
      <a
        className="sidebar-promo-card"
        href={HACKER_CITY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="sidebar-promo-banner"
          src={BANNER_SRC}
          alt="Hacker City"
          width={640}
          height={360}
          loading="lazy"
          decoding="async"
        />
      </a>
    </div>
  )
}